import { render, staticRenderFns } from "./WorkspaceLogin.vue?vue&type=template&id=e5108e60"
import script from "./WorkspaceLogin.vue?vue&type=script&lang=js"
export * from "./WorkspaceLogin.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceLogin.vue?vue&type=style&index=0&id=e5108e60&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports